import { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Map from './Charts/Map';
import CompatibilidadSuelo from './CompatibilidadSuelo/CompatibilidadSuelo';
import ConsultaComprobante from './ConsultaComprobante/ConsultaComprobante';
import ConsultaDeuda from './ConsultaDeuda/ConsultaDeuda';
import Home from './Home';
import Icus from './Icus/Icus';
import LineaFabrica from './LineaFabrica/LineaFabrica';
import Calculator from './Login/Calculator.jsx';
import MobileGeoPortal from './MobileGeoPortal/GeoPortal.js';
import ModuleTemplate from './modulos/ModuleTemplate';
 
class Router extends Component {
    render() {
        return (
            <BrowserRouter>
                <Switch>
                <Route path='/mobileportal' exact component={MobileGeoPortal} />
                <Route path='/geoportal' exact component={Map} />
                    <ModuleTemplate>
                        <Route component={({ match }) =>
                            <div>
                                <Route path='/' exact component={Home} />
                                <Route path='/mapa' exact component={Map} />
                                <Route path='/consulta_deuda' exact component={ConsultaDeuda} />
                                <Route path='/consulta_comprobante' exact component={ConsultaComprobante} />
                                <Route path='/linea_fabrica' exact component={LineaFabrica} />
                                <Route path='/icus' exact component={Icus} />
                                <Route path='/icus/predio/:predio/:id' exact component={CompatibilidadSuelo} />
                                <Route path='/calculator' exact component={Calculator} />
                            </div>
                        } />
                    </ModuleTemplate>
                    
                </Switch>
            </BrowserRouter>
        );
    }

}
export default Router;
